import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://yulymmwkduwrqnaytjub.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl1bHltbXdrZHV3cnFuYXl0anViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ5NjIzNjUsImV4cCI6MjA3MDUzODM2NX0.6BAl0gFON9ziTZJjD0P3mae-Jx_Iuc8b0Q0VMzvuOMQ'

if(SUPABASE_URL == 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY == '<ANON_KEY>'){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})